import React from 'react'

import { Col, Form, Input, Row } from 'antd'

const Contact = () => (
  <Row style={{ margin: 15 }}>
    <Col span={24}>
      <Form.Item label="Contact name" name="contact_name">
        <Input />
      </Form.Item>

      <Form.Item
        label="Contact phone"
        name="contact_phone"
        rules={[
          {
            message: 'Please add a valid phone number!',
            pattern: new RegExp(/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im),
          },
        ]}
      >
        <Input />
      </Form.Item>
    </Col>
  </Row>
)

export default Contact
